export default "__VITE_ASSET__c7557379__$_?nuxt_component=async__"